import { FC } from 'react';
import { i18n as I18n } from 'utils/i18n';
import SearchQuery from './searchQuery';

interface Props {
  previousSearches?: SearchOptions[];
  onClick: (options: SearchOptions) => void;
}

export interface SearchOptions {
  location?: string;
  property?: string[];
  distance?: number;
  capacity?: number;
  facets?: string[];
}

const PreviousSearches: FC<Props> = ({ previousSearches = [], onClick }) => {
  const hasPreviousSearches = previousSearches.length > 0;

  return (
    hasPreviousSearches && (
      <div className="previous-searches">
        <div className="previous-searches__title">
          <h3>{I18n.t('previous_searches.title')}</h3>
        </div>

        <div className="previous-searches__inner">
          <ul className="previous-searches__list">
            {previousSearches.map((search, index) => (
              <SearchQuery
                key={`${search.location}-${search.distance}-${search.capacity}-${index}`}
                options={search}
                onClick={onClick}
              />
            ))}
          </ul>
        </div>
      </div>
    )
  );
};

export default PreviousSearches;
